import React from 'react';
import NumberFormat from 'react-number-format';

interface NumberFormatCustomProps {
  inputRef: ((el: HTMLInputElement) => void) | React.Ref<any>;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

export default function CurrencyFormatToField(props: NumberFormatCustomProps) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      inputMode="text"
      isNumericString
      thousandSeparator={' '}
      suffix=" грн."
      fixedDecimalScale={true}
      decimalScale={2}
    />
  );
}